import { render, staticRenderFns } from "./customMain.vue?vue&type=template&id=52f72d5f&scoped=true&"
import script from "./customMain.vue?vue&type=script&scoped=true&lang=js&"
export * from "./customMain.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./customMain.vue?vue&type=style&index=0&id=52f72d5f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f72d5f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/merchant_5Yxh/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52f72d5f')) {
      api.createRecord('52f72d5f', component.options)
    } else {
      api.reload('52f72d5f', component.options)
    }
    module.hot.accept("./customMain.vue?vue&type=template&id=52f72d5f&scoped=true&", function () {
      api.rerender('52f72d5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/decoration/customMain.vue"
export default component.exports